import { Injectable } from '@angular/core';
import BOPCONFIG from '../../../configs/bop/bop.config';
import { CeresBopConfig } from '../../../configs/bop/interfaces/ceres-bop-config.interface';

@Injectable()
export class BopConfigService {
    bopConfig: CeresBopConfig = BOPCONFIG;

    validateLabel(label: string): boolean {
        return this.bopConfig[label];
    }
}
